module.exports = __webpack_public_path__ + "house-blueprint-hazelnut-ice-cream.38641ca60956bf5fde2e.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/house-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/house-blueprint-hazelnut-ice-cream.svg
// module chunks = main